var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body"},[_c('ws-login',{attrs:{"title":"数据采集平台登录","bgImg":_vm.bgImg,"path":_vm.path,"smsCodeShow":_vm.smsCodeShow,"loading":_vm.logining},on:{"refreshAuthCode":_vm.getValidateCode,"login":_vm.login}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }